import React from "react";
import { Autocomplete, Box, Button, ListItem, MenuItem, TextField } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useAuth } from "../../../../../auth/auth";
import { editUserCompetency } from "../../../../../api/apiCall";
import dayjs from 'dayjs';
import { toast } from "react-toastify";

const EditCompetency = ({
    id,
    profileInfo,
    competencies,
    selectedCompetency,
    setSelectedCompetency,
    expDate,
    setExpDate,
    skillStatus,
    setSkillStatus,
    setIsModalEditCompetencyOpen,
    getWorkerInfo
}: any) => {
    const {state} = useAuth();

    const editTicket = async () => {
        const response = await editUserCompetency(state.user?.token, {
            userId: profileInfo.id,
            id: id,
            skillId: selectedCompetency.id,
            expDate: expDate,
            skillStatus: skillStatus,
        })
        if(response) {
            setIsModalEditCompetencyOpen(false);
            toast.success('Ticket added successfully');
            getWorkerInfo();
        }
    }

    return (
        <Box display="grid" gridTemplateColumns={{xs: "1fr", md: "1fr"}} gap={4} mt={4}>
            <Autocomplete
                size="small"
                disabled
                options={competencies}
                value={competencies.find((ticket: any) => ticket.id === selectedCompetency) || selectedCompetency}
                onChange={(_, newValue) => setSelectedCompetency(newValue)}
                getOptionLabel={(option: any) => option.skillName}
                renderOption={(props, option) => (
                    <ListItem {...props} key={option.skillName}>
                        {option.skillName}
                    </ListItem>
                )}
                renderInput={(params) => (
                    <TextField {...params} label="Competency" placeholder="Select Competency" />
                )}
            />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                    <DatePicker
                        slotProps={{textField: { size: 'small', fullWidth: true }}}
                        label="Expiration Date"
                        format="DD/MM/YYYY"
                        value={expDate ? dayjs(expDate) : null}
                        onChange={(value) => setExpDate(value ? value.toISOString() : null)}
                    />
                </DemoContainer>
            </LocalizationProvider>
            <TextField
                select
                value={skillStatus}
                id="demo-select-small"
                size="small"
                label="Status"
                sx={{mb: 2}}
                onChange={(e: any) => setSkillStatus(e.target.value)}
            >
                <MenuItem value={0}>Pending</MenuItem>
                <MenuItem value={1}>Approved</MenuItem>
                <MenuItem value={2}>Denied</MenuItem>
                <MenuItem value={3}>Not Verified</MenuItem>
            </TextField>
            <div className="center-button-div">
                <Button variant="contained" sx={{boxShadow: 'none'}} onClick={editTicket}>
                    Edit Competency
                </Button>
            </div>
        </Box>
    )
}

export default EditCompetency;